<template>
    <div class="colored-letter-square" :style="{backgroundColor: bgcolor}">
        {{ initials }}
    </div>
</template>

<script>

export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        length: {
            type: Number,
            default: 1,
            validator: function(value) {
                return value == 1 || value == 2;
            },
        },
        uppercase: {
            type: Boolean,
            default: true,
        },
        color: {
            type: String,
        }
    },

    data() {
        return {
            colorArray: [
                '#9acd7d',
                '#2286c3',
                '#ffab91',
                '#836fa9',
                '#cdc07d',
                '#bf5f82',
                '#b0bec5',
                '#bf8239',
                '#9ddbd7',
                '#c97b63',
                '#f5b266',
                '#db9d9d',
                '#9b9050',
                '#6a9c4f',
                '#64b5f6',
                '#808e95',
                '#6da9a6',
                '#b39ddb',
                '#db9dd9',
                '#a96ea7',
                '#a86e6f',
                '#f48fb1',
            ],
        }
    },

    computed: {
        initials() {
            // if length is 1, get the upper case of
            if (this.length == 1) {
                return this.maybeUppercase(this.name.charAt(0));
            }
            // length is 2 and 1 word
            if (this.name.split(' ').length == 1) {
                return this.maybeUppercase(this.name.slice(0,2));
            }
            // length is 2 and multiple words
            var words = this.name.split(' ');
            return this.maybeUppercase(words[0].charAt(0) + words[1].charAt(0));
        },
        bgcolor() {
            if (!this.color) {
                return this.randomColor();
            }
            if (this.color.charAt(0) == "#") {
                return this.color;
            }
            var int = parseInt(this.color);
            if (!isNaN(int) && int > -1 && int < this.colorArray.length-1) {
                return this.colorArray[int];
            }
            return "#007d40";
        },
    },

    methods: {
        maybeUppercase(input) {
            // if uppercase is true, toUpperCase() it
            if (this.uppercase) {
                return input.toUpperCase();
            }
        },
        randomColor() {
            return this.colorArray[Math.floor(Math.random() * this.colorArray.length)];
        },
    },
}

</script>
